"use client"

/**
 * Opens `/home?flow=` and `/student?flow=` as that sign-in role.
 *
 * Login keeps its own reading of `?flow=`, because a flow that still asks a
 * question has to stay on the form.
 */

import * as React from "react"
import { useLocation, useNavigate, useSearchParams } from "react-router"

import { getLoginFlows } from "@/lib/login-flow"
import { PRODUCTS_HOME_PATH } from "@/lib/post-auth-landing"
import {
  flowNeedsSignInChoices,
  openSignInRoleFromLink,
  requestedSignInFlowId,
  signInRolePath,
} from "@/lib/sign-in-role-link"
import { STUDENT_HOME_PATH } from "@/lib/student-shell"

export function SignInRoleQuery() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const flowParam = searchParams.get("flow")

  React.useLayoutEffect(() => {
    if (pathname !== PRODUCTS_HOME_PATH && pathname !== STUDENT_HOME_PATH) return
    const id = requestedSignInFlowId(flowParam)
    if (!id) return

    const destination = openSignInRoleFromLink(id)
    if (!destination) {
      const flow = getLoginFlows().find(entry => entry.id === id)
      if (flow && flowNeedsSignInChoices(flow)) {
        navigate(signInRolePath(id), { replace: true })
      }
      return
    }

    const dest = new URL(destination, "http://local.invalid")
    if (pathname === dest.pathname && searchParams.get("flow") === id) return
    navigate(`${dest.pathname}${dest.search}`, { replace: true })
  }, [flowParam, navigate, pathname, searchParams])

  return null
}
